import React from 'react';
import { useField } from 'formik';
import Select from '..';

const SelectMemo = React.memo(Select);

const SelectCFormik = (props) => {
	const { name } = props;
	const [field, meta] = useField(name);

	if (!name) return 'For Select connected to Formik name is required!';

	return (
		<SelectMemo
			{...props}
			value={field.value ?? ''}
			onChange={field.onChange}
			onBlur={field.onBlur}
			error={(meta.touched || meta.initialTouched) && meta.error}
		/>
	);
};

SelectCFormik.propTypes = {
	...Select.propTypes,
};

export default SelectCFormik;
